import { useCookies } from "react-cookie";

const useSiteCookies = () => {
    const [cookies, setCookie, removeCookie] = useCookies([
        'currentUser',
        'isLoggedIn',
        'userRole',
        'token',
        'award_id',
        'section',
    ]);

    const getCurrentUser = () => cookies.currentUser;
    const getToken = () => cookies.token;
    const getRoleLink = () => cookies.roleLink;
    const getIsLoggedIn = () => cookies.isLoggedIn;
    const getUserRole = () => cookies.userRole;
    const getUserDetails = () => cookies.userDetails;
    const getAwardId = () => cookies.award_id;
    const getSection = () => cookies.section;

    return {
        currentUser: getCurrentUser(),
        token: getToken(),
        roleLink: getRoleLink(),
        isLoggedIn: getIsLoggedIn(),
        userRole: getUserRole(),
        userDetails: getUserDetails(),
        award_id: getAwardId(),
        section: getSection(),
        setCookie,
        removeCookie
    };
};

export default useSiteCookies;